import * as React from "react";

const CENPunchoutArrowturndown: React.FC = () => {
    return (
        <svg width="38" height="50" viewBox="0 0 38 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M24.9375 32.2133V10.5625C24.9375 5.83839 21.0968 2 16.375 2H7.1875C4.63425 2 2.5625 4.06848 2.5625 6.625C2.5625 9.18152 4.63425 11.25 7.1875 11.25H15.6875V32.2117L13.0827 29.6053L13.0823 29.6048C11.2758 27.7984 8.34836 27.7984 6.54192 29.6048C4.73625 31.4105 4.73548 34.3362 6.53961 36.1429C6.54038 36.1436 6.54115 36.1444 6.54192 36.1452L16.9631 46.6402L16.9681 46.6452C17.8494 47.5265 18.9527 48 20.2387 48C21.4558 48 22.6601 47.5749 23.5856 46.6382L34.0806 36.1431C35.8854 34.3383 35.8903 31.4166 34.0823 29.6085C32.2758 27.8021 29.3484 27.8021 27.5419 29.6085L27.5418 29.6086L24.9375 32.2133Z"
                fill="#E0DFE0"
                stroke="white"
                stroke-width="4"
            />
        </svg>
    );
};

export default React.memo(CENPunchoutArrowturndown);
